var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterBg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 123,
    viewBox: "0 0 110 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.459 126.125C163.585 152.156 143.74 178.201 123.869 204.232C120.69 208.422 114.735 209.214 110.526 206.03C85.6686 187.175 70.3074 172.362 44.3347 153.049C37.8504 147.636 25.1108 135.292 19.9351 115.524C11.066 81.6325 31.8037 54.0658 35.517 49.1416C46.7342 34.1977 60.4056 26.4787 68.2016 22.8543C109.952 54.4743 140.609 81.3908 181.638 112.709C185.823 115.896 186.64 121.935 183.46 126.125L183.459 126.125Z",
    fill: "url(#paint0_linear_1321_547)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1321_547",
    x1: 0,
    y1: 41.1289,
    x2: 164.548,
    y2: 176.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59C7C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FA9A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBg4);
export default __webpack_public_path__ + "static/media/footer-bg-4.71a01974ee332306b567c958aedcf10f.svg";
export { ForwardRef as ReactComponent };